import script from "./RoleTag.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleTag.vue?vue&type=script&setup=true&lang=js"

import "./RoleTag.vue?vue&type=style&index=0&id=3d0d0bc9&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d0d0bc9"]])

export default __exports__